module.exports = __webpack_public_path__ + "img/06.5321041b.jpg";